/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-06 17:07:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-07 11:37:38
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/Service/index.tsx
 */
import React from 'react';

import css from './css.module.less';

import { useParams } from 'react-router-dom';
import { IParams } from 'src/pages/SalesChannelContentEditor/common';

import { useDispatch, useSelector } from 'react-redux';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getService,
  getServices,
  onCollapseOpen,
  onErrorChange,
  onServiceChange,
} from '../slice';

import { Collapse, Select } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import GreenLink from 'src/components/Link/GreenText';
import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
import GeneralCollapseContent from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseContent';
import GeneralCollapseHeader from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseHeader';
import GeneralCollapseWrapper from 'src/constrains/SalesChannelPreviewPageComponents/GeneralCollapseWrapper';

import { useErrorOnChange2 } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { validateService } from 'src/pages/SalesChannelProductsConfig/SalesChannelProductCustomization/tools';
import { i18nGet } from 'src/tools/tools';
const Service = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { disabled } = props;
  const services = useSelector(getServices()); //services select options
  //const tcs = useSelector(getTCs());
  const _id = EnumCollapseId.service;
  const _d = useDispatch();
  const _open = useSelector(getCollapseOpenStatus(_id));
  const _params: IParams = useParams();
  const { saleChannelUuid } = _params;

  const { selectedServiceUuid, termsAndConditionsUuid } = useSelector(
    getService(),
  );

  const { display: _display, hasError } =
    useSelector(getCollapseValidationMsgDisplay(_id)) || {};

  const { hasError: _e, specificErr } = validateService({
    selectedServiceUuid,
    termsAndConditionsUuid,
  });

  const { selectedServiceUuidError = [] } = specificErr;

  useErrorOnChange2({
    latestHasError: _e,
    previousHasError: hasError,
    dispatch: _d,
    action: onErrorChange,
    id: _id,
  });

  const handleOnCollapseOpen = (status) => {
    const _g = status ? [_id] : [];
    _d(onCollapseOpen({ idArr: _g }));
  };

  const renderTitle = () => {
    return (
      <GeneralCollapseHeader
        err={_display && hasError}
        content={getI18n('general.service.service')}
      />
    );
  };

  const convertServiceList = () => {
    return services.map((i) => {
      const { productName, uuid } = i;
      return {
        value: uuid,
        label: productName,
      };
    });
  };
  // const convertTCList = () => {
  //   return tcs.map((i) => {
  //     const { name, uuid } = i;
  //     return {
  //       value: uuid,
  //       label: name,
  //     };
  //   });
  // };
  const handleOnServiceChange = (data) => {
    _d(onServiceChange({ data }));
  };

  const handleErr = React.useMemo(() => {
    if (_display) {
      return <ErrorDisplay2 open={_open} hasError={hasError} err={[]} />;
    } else {
      return null;
    }
  }, [hasError, _display, _open]);

  return (
    <GeneralCollapseWrapper>
      <Collapse
        err={handleErr}
        id={_id}
        open={_open}
        title={renderTitle()}
        content={
          <GeneralCollapseContent>
            <Section bottomBorder>
              <ItemWrapper
                bottomTitleContainerClassName={css.bottomText}
                bottomTitle={getI18n(
                  'salesChannelProductCustomization.index.selectServiceDesc',
                )}
                title={`${getI18n(
                  'salesChannelProductCustomization.index.selectService',
                )}*`}>
                <Select
                  error={selectedServiceUuidError.length > 0 && _display}
                  help={selectedServiceUuidError.join(' ')}
                  value={selectedServiceUuid}
                  onChange={(e) => {
                    handleOnServiceChange({ selectedServiceUuid: e });
                  }}
                  size='large'
                  optionsList={convertServiceList()}
                  disabled={disabled}
                />
              </ItemWrapper>
              <GreenLink
                className={css.link}
                to={`/salesChannel/products/${saleChannelUuid}`}>
                {getI18n(
                  'salesChannelProductCustomization.index.setupinStoreSalesChannelProduct',
                )}
              </GreenLink>
            </Section>

            {/* <Section>
              <ItemWrapper title='Terms & Conditions (Optional)'>
                <Select
                  value={termsAndConditionsUuid}
                  onChange={(e) => {
                    handleOnServiceChange({ termsAndConditionsUuid: e });
                  }}
                  size='large'
                  optionsList={convertTCList()}
                />
              </ItemWrapper>
              <GreenLink
                className={css.link}
                to={`/salesChannel/termsAndCondition/list/${saleChannelUuid}`}>
                {'Set up in Legal'}
              </GreenLink>
            </Section> */}
          </GeneralCollapseContent>
        }
        clickToExpand
        //open={true}
        expandOffset={12}
        onClickTrigger={handleOnCollapseOpen}
      />
    </GeneralCollapseWrapper>
  );
};
export default Service;
